/*
  tko.util
  ===

*/

export * from './array'
export * from './async'
export * from './compat'
export * from './error'
export * from './object'
export * from './string'
export * from './css'
export { default as options, defineOption, Options } from './options'

// DOM;
export * from './dom/event'
export * from './dom/info'
export * from './dom/manipulation'
export * from './dom/fixes'
export * from './dom/html'
export * from './dom/disposal'
export * from './dom/selectExtensions'

// Sub-Modules;
import * as memoization from './memoization'
import * as tasks from './tasks'
import * as virtualElements from './dom/virtualElements'
import * as domData from './dom/data'

export { tasks, virtualElements, domData, memoization }
